import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSliderModule } from '@angular/material/slider';
import { SimplebarAngularModule } from 'simplebar-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DraftWindowComponent } from './draft-window/draft-window.component';
import { ChampionListComponent } from './champion-list/champion-list.component';
import { ChampionSearchComponent } from './champion-search/champion-search.component';
import { ChampionListMemberComponent } from './champion-list-member/champion-list-member.component';
import { DraftPlayerComponent } from './draft-player/draft-player.component';
import { DraftTeamHeaderComponent } from './draft-team-header/draft-team-header.component';
import { ChampionBanComponent } from './champion-ban/champion-ban.component';
import { LoadingWindowComponent } from './loading-window/loading-window.component';
import { DraftTimerComponent } from './draft-timer/draft-timer.component';
import { MapWindowComponent } from './map-window/map-window.component';
import { MapMarkerComponent } from './map-marker/map-marker.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PenWindowComponent } from './pen-window/pen-window.component';
import { CanvasWindowComponent } from './canvas-window/canvas-window.component';
import { NavWindowComponent } from './nav-window/nav-window.component';

@NgModule({
  declarations: [
    AppComponent,
    LoadingWindowComponent,
    DraftWindowComponent,
    ChampionListComponent,
    ChampionListMemberComponent,
    ChampionSearchComponent,
    DraftTeamHeaderComponent,
    DraftPlayerComponent,
    ChampionBanComponent,
    DraftTimerComponent,
    MapWindowComponent,
    MapMarkerComponent,
    PenWindowComponent,
    CanvasWindowComponent,
    NavWindowComponent
  ],
  entryComponents: [
    ChampionListMemberComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    DragDropModule,
    MatSliderModule,
    MatTooltipModule,
    SimplebarAngularModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
